export const checkUserAndReturnFilterForRoles = () => {
  const who = localStorage.getItem('userRole');
  if (who === 'REGIONAL_ADMINISTRATOR')
    return {
      canSelect: true,
      name_in: ['ROIV_SPECIALIST', 'REGIONAL_SCHOOL'],
    };
  if (who === 'FCPSR_ADMINISTRATOR' || who === 'FCPSR_SPECIALIST')
    return {
      canSelect: true,
      name_in: [
        'FCPSR_SPORTING_EVENT_OPERATOR',
        'FCPSR_SPECIALIST',
        'FCPSR_ADMINISTRATOR',
        'FCPSR_ROIV_SPECIALIST',
        'REGIONAL_SCHOOL',
        'GSK_REFEREE',
      ],
    };
  else if (who === 'FCPSR_SPORTING_EVENT_OPERATOR')
    return {
      canSelect: true,
      name_in: ['GSK_REFEREE'],
    };
  else if (who === 'ROIV_SPECIALIST')
    return {
      canSelect: true,
      name_in: ['REGIONAL_SCHOOL'],
    };
  else return { canSelect: true };
};
